//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { INetworkItem } from '@models/INetworkItem';
import { IProduct } from '@models/IProduct';
import { TaggingFeedType } from '@tagging/models/taggingModels';

export interface IModerationItem {
  networkItem: INetworkItem;
  products?: IProduct[];
  moderationMetadata?: IModerationItemMetadata;
}

export interface IModerationItemMetadata {
  publishedTimestamp?: number;
  itemType: TaggingFeedType;
}

export interface IModerationItemStatusData {
  text: string;
  color: MODERATION_STATUS_COLORS;
}

export enum MODERATION_STATUS_COLORS {
  GREEN = 'green',
  YELLOW = 'yellow',
  RED = 'red',
}

export enum REQUIRED_MODERATION_ACTIONS {
  TAG_PRODUCTS = 'tagProducts'
}
